// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-hero {
  position: relative;
  padding: 24px 20px;
  overflow: hidden;
  background: #f5f9ff;
  border: 1px solid #cfe1ff;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1019607843);
}
.home-hero__content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.home-hero__content picture {
  display: none;
}
.home-hero__copy {
  display: flex;
  flex-direction: column;
}
.home-hero__copy p {
  font-family: Figtree;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
  color: var(--sebrae-gray);
}
.home-hero__copy h3 {
  font-family: Figtree;
  font-size: 33px;
  font-weight: 700;
  margin-bottom: 24px;
  color: var(--sebrae-blue-6);
}
.home-hero__copy h4 {
  font-family: Figtree;
  margin-bottom: 16px;
  font-size: 19px;
  font-weight: 700;
  color: var(--sebrae-gray);
}
.home-hero__copy .monitoring-lead {
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
  color: var(--sebrae-gray);
}
.home-hero__copy .monitoring-lead strong {
  font-weight: 700;
}
.home-hero__copy .monitoring-lead--overdue {
  color: #BF303C;
}
.home-hero__copy .reminder-title {
  font-family: Figtree;
  font-size: 19px;
  font-weight: 700;
  margin-bottom: 4px;
  color: var(--sebrae-gray);
}
.home-hero__copy .reminder-description {
  display: block;
  font-family: Figtree;
  font-size: 13px;
  color: var(--sebrae-gray);
  margin-bottom: 16px;
}
.home-hero__month-badge {
  display: inline-flex;
  align-self: flex-start;
  padding: 8px;
  margin-bottom: 16px;
  border-radius: 8px;
  background: #CFE2FC;
  color: var(--sebrae-blue-6);
  font-family: Figtree;
  font-size: 23px;
  font-weight: 700;
  line-height: 1;
}
.home-hero__month-badge--overdue {
  background: #F3D8DA;
  color: #BF303C;
}
.home-hero__reminder-steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.home-hero__reminder-step {
  display: flex;
  align-items: center;
  gap: 8px;
}
.home-hero__reminder-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #9285F9;
}
.home-hero__reminder-step-icon img {
  width: 12px;
  height: 12px;
  display: block;
}
.home-hero__reminder-step-icon-image--folder {
  width: 13.55px !important;
}
.home-hero__reminder-step-text {
  font-family: Figtree;
  font-size: 11px;
  font-weight: 400;
  color: var(--sebrae-gray);
}
.home-hero__steps {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
.home-hero__step {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.home-hero__step-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
.home-hero__step-card {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.home-hero__step-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--sebrae-purple);
}
.home-hero__step-card-icon img {
  width: 12px;
  height: 12px;
  display: block;
}
.home-hero__step-card-icon--monitoring, .home-hero__step-card-icon--comparison-lab {
  background: var(--sebrae-purple);
}
.home-hero__step-card-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 180px;
}
.home-hero__step-card-copy strong {
  font-family: Figtree;
  font-size: 14px;
  font-weight: 700;
  color: var(--sebrae-gray);
  line-height: 1.2;
}
.home-hero__step-card-copy span {
  font-family: Figtree;
  font-size: 11px;
  line-height: 1.3;
  color: var(--sebrae-gray);
}
.home-hero__step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  border-radius: 4px;
  background: #9285F9;
  color: var(--sebrae-white);
  font-size: 11px;
  font-weight: 700;
  padding: 3.5px 6.5px;
}
.home-hero__step-text {
  font-family: Figtree;
  font-size: 11px;
  color: var(--sebrae-gray);
}
.home-hero__progress {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 20px;
}
.home-hero__progress-track {
  position: relative;
  width: 100%;
  max-width: 260px;
  height: 32px;
  overflow: hidden;
  background: var(--sebrae-light-gray4);
  border: 4px solid var(--sebrae-light-gray);
  border-radius: 999px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.home-hero__progress-track span {
  display: block;
  height: 100%;
  border-radius: 32px;
  background: #58C4DA;
}
.home-hero__progress-label {
  font-size: 12px;
  white-space: nowrap;
  font-weight: 700;
  color: var(--sebrae-dark-gray2);
}
.home-hero__actions {
  margin-top: 24px;
}
.home-hero__actions button {
  font-family: Figtree;
  font-size: 16px;
  font-weight: 700;
  min-width: 220px;
  padding: 12px 22px;
  color: var(--sebrae-white);
  background: var(--sebrae-blue);
}
@media screen and (max-width: 359px) {
  .home-hero__actions button {
    font-size: 12px;
  }
}
.home-hero--with-ad .home-hero__content picture {
  display: none;
}
.home-hero--with-ad .home-hero__copy {
  max-width: 100%;
}
@media screen and (min-width: 768px) {
  .home-hero {
    padding: 40px 32px;
  }
  .home-hero__content {
    position: relative;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0;
  }
  .home-hero__content picture {
    display: block;
    position: absolute;
    right: 20px;
    bottom: -90px;
    width: 42%;
    max-width: 515.2px;
    pointer-events: none;
  }
  .home-hero__content picture img {
    display: block;
    width: 100%;
    height: auto;
    margin: 0;
  }
  .home-hero__copy {
    flex: 1 1;
    min-width: 0;
    max-width: calc(58% - 16px);
  }
  .home-hero__copy .monitoring-lead {
    font-size: 19px;
  }
  .home-hero--with-ad {
    min-height: 100%;
  }
  .home-hero--with-ad .home-hero__copy {
    max-width: 100%;
  }
  .home-hero--with-ad .home-hero__steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .home-hero--with-ad .home-hero__step-cards {
    grid-template-columns: 1fr;
  }
  .home-hero__steps {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 20px;
    row-gap: 12px;
  }
  .home-hero__step-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
    max-width: 460px;
  }
  .home-hero__reminder-steps {
    max-width: 340px;
  }
  .home-hero__actions {
    margin-top: 32px;
  }
  .home-hero__media--monitoring-reminder {
    right: -60px;
    bottom: calc(-0.21 * min(60vw, 700px));
    width: 60%;
    max-width: 700px;
  }
  .home-hero__media--monitoring-overdue {
    max-width: 789.14px;
    bottom: 0;
    width: 56%;
  }
  .home-hero__content picture.home-hero__media--monitoring-reminder {
    right: -60px;
    bottom: calc(-0.21 * min(60vw, 700px));
    width: 60%;
    max-width: 700px;
  }
  .home-hero__content picture.home-hero__media--monitoring-overdue {
    bottom: 0;
    width: 55%;
    max-width: 789.14px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1042px) {
  .home-hero__content picture.home-hero__media--monitoring-reminder {
    bottom: calc(-0.32 * min(52vw, 700px));
  }
}
@media screen and (min-width: 768px) and (max-width: 1269px) {
  .home-hero__content picture.home-hero__media--monitoring-overdue {
    bottom: 0;
  }
}
@media screen and (min-width: 768px) {
  .home-hero__image--monitoring-overdue {
    transform: translateY(137px);
    transform-origin: bottom right;
  }
  .home-hero .monitoring-lead, .home-hero__reminder-steps,
  .home-hero .reminder-description,
  .home-hero .reminder-title {
    position: relative;
    z-index: 1;
    white-space: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/home-hero/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uDAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACE,aAAA;AACN;AAGE;EACE,aAAA;EACA,sBAAA;AADJ;AAGI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AADN;AAII;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;AAFN;AAKI;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAHN;AAMI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAJN;AAMM;EACE,gBAAA;AAJR;AAOM;EACE,cAAA;AALR;AASI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAPN;AAUI;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AARN;AAYE;EACE,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAVJ;AAYI;EACE,mBAAA;EACA,cAAA;AAVN;AAcE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAbJ;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAdJ;AAgBI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAdN;AAkBE;EACE,yBAAA;AAhBJ;AAmBE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AApBJ;AAuBE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AArBJ;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;AAtBJ;AAwBI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAtBN;AAyBI;EAEE,gCAAA;AAxBN;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AA1BJ;AA4BI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AA1BN;AA6BI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA3BN;AA+BE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA7BJ;AAgCE;EACE,oBAAA;EACA,eAAA;EACA,yBAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AA/BJ;AAkCE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;EACA,0CAAA;EACA,oBAAA;EACA,8CAAA;AAhCJ;AAkCI;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAhCN;AAoCE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;AAlCJ;AAqCE;EACE,gBAAA;AAnCJ;AAqCI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,8BAAA;AAnCN;AAuCE;EAEI;IACE,eAAA;EAtCN;AACF;AAoEM;EACE,aAAA;AAlER;AAsEI;EACE,eAAA;AApEN;AAwEE;EAhUF;IAiUI,kBAAA;EArEF;EAuEE;IACE,kBAAA;IACA,mBAAA;IACA,uBAAA;IACA,2BAAA;IACA,MAAA;EArEJ;EAuEI;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,aAAA;IACA,UAAA;IACA,kBAAA;IACA,oBAAA;EArEN;EAuEM;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,SAAA;EArER;EA0EE;IACE,SAAA;IACA,YAAA;IACA,2BAAA;EAxEJ;EA0EI;IACE,eAAA;EAxEN;EA4EE;IACE,gBAAA;EA1EJ;EA4EI;IACE,eAAA;EA1EN;EA6EI;IACE,gDAAA;EA3EN;EA8EI;IACE,0BAAA;EA5EN;EAgFE;IACE,gDAAA;IACA,gBAAA;IACA,aAAA;EA9EJ;EAiFE;IACE,gDAAA;IACA,SAAA;IACA,gBAAA;EA/EJ;EAkFE;IACE,gBAAA;EAhFJ;EAmFE;IACE,gBAAA;EAjFJ;EA2FI;IACE,YAAA;IACA,sCAAA;IACA,UAAA;IACA,gBAAA;EAzFN;EA4FI;IACE,mBAAA;IACA,SAAA;IACA,UAAA;EA1FN;EA2GI;IACE,YAAA;IACA,sCAAA;IACA,UAAA;IACA,gBAAA;EAzGN;EA4GI;IACE,SAAA;IACA,UAAA;IACA,mBAAA;EA1GN;AACF;AA8GE;EAEI;IACE,sCAAA;EA7GN;AACF;AAiHE;EAEI;IACE,SAAA;EAhHN;AACF;AAoHE;EAEI;IACE,4BAAA;IACA,8BAAA;EAnHN;EAuHE;;;IAIE,kBAAA;IACA,UAAA;IACA,mBAAA;EAtHJ;AACF","sourcesContent":[".home-hero {\n  position: relative;\n  padding: 24px 20px;\n  overflow: hidden;\n  background: #f5f9ff;\n  border: 1px solid #cfe1ff;\n  border-radius: 5px;\n  box-shadow: 0px 4px 4px 0px #0000001a;\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    picture {\n      display: none;\n    }\n  }\n\n  &__copy {\n    display: flex;\n    flex-direction: column;\n\n    p {\n      font-family: Figtree;\n      font-size: 16px;\n      font-weight: 700;\n      margin-bottom: 4px;\n      color: var(--sebrae-gray);\n    }\n\n    h3 {\n      font-family: Figtree;\n      font-size: 33px;\n      font-weight: 700;\n      margin-bottom: 24px;\n      color: var(--sebrae-blue-6);\n    }\n\n    h4 {\n      font-family: Figtree;\n      margin-bottom: 16px;\n      font-size: 19px;\n      font-weight: 700;\n      color: var(--sebrae-gray);\n    }\n\n    .monitoring-lead {\n      font-family: Figtree;\n      font-size: 14px;\n      font-weight: 400;\n      margin-bottom: 12px;\n      color: var(--sebrae-gray);\n      \n      strong {\n        font-weight: 700;\n      }\n\n      &--overdue {\n        color: #BF303C;\n      }\n    }\n\n    .reminder-title {\n      font-family: Figtree;\n      font-size: 19px;\n      font-weight: 700;\n      margin-bottom: 4px;\n      color: var(--sebrae-gray);\n    }\n\n    .reminder-description {\n      display: block;\n      font-family: Figtree;\n      font-size: 13px;\n      color: var(--sebrae-gray);\n      margin-bottom: 16px;\n    }\n  }\n\n  &__month-badge {\n    display: inline-flex;\n    align-self: flex-start;\n    padding: 8px;\n    margin-bottom: 16px;\n    border-radius: 8px;\n    background: #CFE2FC;\n    color: var(--sebrae-blue-6);\n    font-family: Figtree;\n    font-size: 23px;\n    font-weight: 700;\n    line-height: 1;\n\n    &--overdue {\n      background: #F3D8DA;\n      color: #BF303C;\n    }\n  }\n\n  &__reminder-steps {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__reminder-step {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__reminder-step-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n    border-radius: 4px;\n    background: #9285F9;\n\n    img {\n      width: 12px;\n      height: 12px;\n      display: block;\n    }\n  }\n\n  &__reminder-step-icon-image--folder {\n    width: 13.55px !important;\n  }\n\n  &__reminder-step-text {\n    font-family: Figtree;\n    font-size: 11px;\n    font-weight: 400;\n    color: var(--sebrae-gray);\n  }\n\n  &__steps {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  &__step {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  &__step-cards {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  &__step-card {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  &__step-card-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n    border-radius: 4px;\n    background: var(--sebrae-purple);\n\n    img {\n      width: 12px;\n      height: 12px;\n      display: block;\n    }\n\n    &--monitoring,\n    &--comparison-lab {\n      background: var(--sebrae-purple);\n    }\n  }\n\n  &__step-card-copy {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-width: 180px;\n\n    strong {\n      font-family: Figtree;\n      font-size: 14px;\n      font-weight: 700;\n      color: var(--sebrae-gray);\n      line-height: 1.2;\n    }\n\n    span {\n      font-family: Figtree;\n      font-size: 11px;\n      line-height: 1.3;\n      color: var(--sebrae-gray);\n    }\n  }\n\n  &__step-number {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    margin-top: 2px;\n    border-radius: 4px;\n    background: #9285F9;\n    color: var(--sebrae-white);\n    font-size: 11px;\n    font-weight: 700;\n    padding: 3.5px 6.5px;\n  }\n\n  &__step-text {\n    font-family: Figtree;\n    font-size: 11px;\n    color: var(--sebrae-gray);\n  }\n\n  &__progress {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 0 0 20px;\n  }\n\n  &__progress-track {\n    position: relative;\n    width: 100%;\n    max-width: 260px;\n    height: 32px;\n    overflow: hidden;\n    background: var(--sebrae-light-gray4);\n    border: 4px solid var(--sebrae-light-gray);\n    border-radius: 999px;\n    box-shadow: 0px 2px 4px 0px #00000033;\n\n    span {\n      display: block;\n      height: 100%;\n      border-radius: 32px;\n      background: #58C4DA;\n    }\n  }\n\n  &__progress-label {\n    font-size: 12px;\n    white-space: nowrap;\n    font-weight: 700;\n    color: var(--sebrae-dark-gray2);\n  }\n\n  &__actions {\n    margin-top: 24px;\n\n    button {\n      font-family: Figtree;\n      font-size: 16px;\n      font-weight: 700;\n      min-width: 220px;\n      padding: 12px 22px;\n      color: var(--sebrae-white);\n      background: var(--sebrae-blue);\n    }\n  }\n\n  @media screen and (max-width: 359px) {\n    &__actions {\n      button {\n        font-size: 12px;\n      }\n    }\n  }\n\n  &__media {\n    &--no-plannings {}\n\n    &--in-progress {}\n\n    &--completed-no-monitoring {}\n\n    &--monitoring-reminder {}\n\n    &--monitoring-overdue {}\n  }\n\n  &__image {\n    &--no-plannings {}\n\n    &--in-progress {}\n\n    &--completed-no-monitoring {}\n\n    &--monitoring-reminder {}\n\n    &--monitoring-overdue {}\n  }\n\n  &--with-ad {\n    .home-hero__content {\n      picture {\n        display: none;\n      }\n    }\n\n    .home-hero__copy {\n      max-width: 100%;\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    padding: 40px 32px;\n\n    &__content {\n      position: relative;\n      flex-direction: row;\n      align-items: flex-start;\n      justify-content: flex-start;\n      gap: 0;\n\n      picture {\n        display: block;\n        position: absolute;\n        right: 20px;\n        bottom: -90px;\n        width: 42%;\n        max-width: 515.2px;\n        pointer-events: none;\n\n        img {\n          display: block;\n          width: 100%;\n          height: auto;\n          margin: 0;\n        }\n      }\n    }\n\n    &__copy {\n      flex: 1;\n      min-width: 0;\n      max-width: calc(100% - 42% - 16px);\n\n      .monitoring-lead {\n        font-size: 19px;\n      }\n    }\n\n    &--with-ad {\n      min-height: 100%;\n\n      .home-hero__copy {\n        max-width: 100%;\n      }\n\n      .home-hero__steps {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n      }\n\n      .home-hero__step-cards {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    &__steps {\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n      column-gap: 20px;\n      row-gap: 12px;\n    }\n\n    &__step-cards {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      gap: 24px;\n      max-width: 460px;\n    }\n\n    &__reminder-steps {\n      max-width: 340px;\n    }\n\n    &__actions {\n      margin-top: 32px;\n    }\n\n    &__media {\n      &--no-plannings {}\n\n      &--in-progress {}\n\n      &--completed-no-monitoring {}\n\n      &--monitoring-reminder {\n        right: -60px;\n        bottom: calc(-0.21 * min(60vw, 700px));\n        width: 60%;\n        max-width: 700px;\n      }\n\n      &--monitoring-overdue {\n        max-width: 789.14px;\n        bottom: 0;\n        width: 56%;\n      }\n    }\n\n    &__image {\n      &--no-plannings {}\n\n      &--in-progress {}\n\n      &--completed-no-monitoring {}\n\n      &--monitoring-reminder {}\n\n      &--monitoring-overdue {}\n    }\n\n    &__content {\n      picture.home-hero__media--monitoring-reminder {\n        right: -60px;\n        bottom: calc(-0.21 * min(60vw, 700px));\n        width: 60%;\n        max-width: 700px;\n      }\n\n      picture.home-hero__media--monitoring-overdue {\n        bottom: 0;\n        width: 55%;\n        max-width: 789.14px;\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) and (max-width: 1042px) {\n    &__content {\n      picture.home-hero__media--monitoring-reminder {\n        bottom: calc(-0.32 * min(52vw, 700px));\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) and (max-width: 1269px) {\n    &__content {\n      picture.home-hero__media--monitoring-overdue {\n        bottom: 0;\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    &__image {\n      &--monitoring-overdue {\n        transform: translateY(137px);\n        transform-origin: bottom right;\n      }\n    }\n\n    .monitoring-lead,\n    &__reminder-steps,\n    .reminder-description,\n    .reminder-title {\n      position: relative;\n      z-index: 1;\n      white-space: nowrap;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
